import { Component, OnInit, Input } from '@angular/core';
import { OrderService } from '../../../common/services/order.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Order } from '../../../common/models/order';
import * as Operator from '../../../common/models/operator';

@Component({
  selector: 'app-order-confirmation',
  templateUrl: './order-confirmation.component.html',
  styleUrls: ['./order-confirmation.component.scss'],
})
export class OrderConfirmationComponent implements OnInit {
  @Input() order: Order;
  orderId = '';
  orderLink = '';
  referenceId = '';
  KEY_ENTER = 13;
  KEY_SPACE = 32;

  isCtlSweden = false;
  isCtlNorway = false;
  isCtlFinland = false;
  isCtlDenmark = false;
  isNoCtl = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private orderService: OrderService
  ) {}

  ngOnInit() {
    const id = +this.route.snapshot.paramMap.get('id');
    this.orderService.getOrder(id).subscribe((order) => this.onOrderRetrieved(order.body));
  }

  onOrderRetrieved(order: Order): void {
    this.order = order;
    this.orderId = order.id + '';
    this.referenceId = order.referenceId;

    if (this.order.isProductBased) {
      this.orderLink = '/order/product-order/' + this.orderId;
    } else {
      this.orderLink = '/order/' + this.orderId;
    }

    this.isCtlSweden = Operator.CtlSwedenOperatorIds.includes(
      this.order.operator.operatorOrganisationId
    );

    this.isCtlNorway = Operator.CtlNorwayOperatorIds.includes(
      this.order.operator.operatorOrganisationId
    );

    this.isCtlFinland = Operator.CtlFinlandOperatorIds.includes(
      this.order.operator.operatorOrganisationId
    );

    this.isCtlDenmark = Operator.CtlDenmarkOperatorIds.includes(
      this.order.operator.operatorOrganisationId
    );

    this.isNoCtl =
      Operator.CtlCountryBasedNoneOperatorIds.includes(
        this.order.operator.operatorOrganisationId
      ) || !(this.isCtlSweden || this.isCtlNorway || this.isCtlFinland || this.isCtlDenmark);
  }

  navigateToOrder() {
    if (this.order.isProductBased) {
      this.router.navigateByUrl('/order/new-order/' + this.orderId);
    } else {
      this.router.navigateByUrl('/order/' + this.orderId);
    }
  }
}
